import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { serviceIcon, serviceLabel, STATUS_LABEL, formatZAR } from "@/lib/constants";
import { Plus } from "lucide-react";

export default function RequestsList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/requests").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  const filters = ["all", "pending", "accepted", "in_progress", "completed"];
  const filtered = filter === "all" ? items : items.filter((i) => i.status === filter);

  return (
    <div>
      <div className="px-6 pt-8 pb-4 flex items-end justify-between">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#3CFF7E] font-display mb-1">Your Jobs</div>
          <h1 className="font-display text-3xl font-black tracking-tight">Requests</h1>
        </div>
        <Link to="/app/request/new" className="h-10 px-3 bg-[#3CFF7E] text-[#0A0A0A] rounded-md flex items-center gap-1 font-bold text-sm" data-testid="new-request-btn">
          <Plus size={16} /> New
        </Link>
      </div>

      <div className="px-6 mb-3 flex gap-2 overflow-x-auto no-scrollbar">
        {filters.map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            data-testid={`filter-${f}`}
            className={`h-8 px-3 rounded-md text-[10px] font-display font-bold uppercase tracking-wider whitespace-nowrap ${
              filter === f ? "bg-[#0B1E5B] text-white" : "bg-white/10 text-[#9CA3AF]"
            }`}
          >
            {f === "all" ? "All" : STATUS_LABEL[f]}
          </button>
        ))}
      </div>

      <div className="px-6 pb-6">
        {loading ? (
          <div className="text-sm text-[#9CA3AF]">Loading...</div>
        ) : filtered.length === 0 ? (
          <div className="text-sm text-[#9CA3AF] border border-dashed border-white/20 rounded-md p-8 text-center">
            No requests found.
          </div>
        ) : (
          <div className="space-y-2">
            {filtered.map((r) => (
              <Link key={r.id} to={`/app/request/${r.id}`} className="block border border-white/10 rounded-md p-4 hover:border-white transition-colors" data-testid={`request-item-${r.id}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3 flex-1">
                    <div className="text-2xl">{serviceIcon(r.serviceType)}</div>
                    <div className="flex-1 min-w-0">
                      <div className="font-display font-bold">{serviceLabel(r.serviceType)}</div>
                      <div className="text-xs text-[#9CA3AF] truncate">{r.description || "No description"}</div>
                      <div className="text-xs text-[#9CA3AF] mt-1">{new Date(r.created_at).toLocaleString()}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <span className={`status-pill status-${r.status}`}>{STATUS_LABEL[r.status]}</span>
                    <div className="font-display font-bold text-sm mt-2">{formatZAR(r.price)}</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
